(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["section-slideshow-v1"] && !Shopify.designMode) return;
  try {
    
   $(document).ready(function(){
  $('.slick-side-h1').slick({
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 5000, // 3 seconds (change if needed)
    arrows: true,
    dots: false,
    fade: true,
    speed: 800,
    pauseOnHover: false,
    pauseOnFocus: false
  });
});

  } catch(e) { console.error(e); }
})();
})();
